import { doc, getDoc, getFirestore } from "firebase/firestore";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { checkDB } from "../../models/DataFunctions";
import addLogDocument from "../addLogDocument";

const stripePortalSession = async (org_id, token, prefix) => {
  const url = prefix + `stripe/customer-portal/${org_id}`;

  // Define the request body
  const body = {};

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return null;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return null;
    }

    const org_id = userSnapshot.get("org_id");

    // Make the POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const responseData = await response.json(); // Convert the response to JSON
    let end = new Date();
    let elapsed = end - start;
    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body
      JSON.stringify(response.data),
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      return responseData; // Return the session ID or relevant data
    } else {
      console.error(`Failed to send invite: ${response.status}`);
      return {
        error: response.status,
        detail:
          responseData.detail || "An error occurred while creating the session",
      };
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
  }
};

export default stripePortalSession;
